import { FlowVas } from '../../interfaces/FlowVas/FlowVas'
import { FlowVasAction } from '../actions/flowVasAction'
import { flowVasActionTypes } from '../types/flowVasActionTypes'

export interface FlowVasState {
  flowVasState: {
    flowVas?: FlowVas[]
    error?: string | undefined
  }
}

const initialState: FlowVasState = {
  flowVasState: { flowVas: [], error: '' }
}

export const flowVasReducer = (
  state: FlowVasState = initialState,
  action: FlowVasAction
): FlowVasState => {
  if (action.type === flowVasActionTypes.GET_FLOW_VAS_EXITO) {
    return {
      ...state,
      flowVasState: {
        flowVas: action.flowVas,
        error: action.error
      }
    }
  }

  return state
}
